import { FC, useState } from 'react';

import { ButtonVariant, Button } from '@pp/core/src/components/controls/button/Button';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';
import { getIsLanguageRTL } from '@pp/core/src/utils/language';

import { useLastGameDataFetcher } from '../../../../store/apiHooks/useLastGameDataFetcher';
import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { useCurrencySymbol } from '../../../gameGrid/hooks';

import { SingleBetRow } from './SingleBetRow';

import styles from './BetsHistoryTable.module.css';

interface BetsHistoryTableProps {
  show: boolean;
}

export const BetHistoryTable: FC<BetsHistoryTableProps> = ({ show }) => {
  const [page, setPage] = useState(1);
  const audioTrigger = useAudioTrigger();
  const currencySymbol = useCurrencySymbol();
  const locale = useSettingsSlice.currentLanguage();
  const isLanguageRTL = getIsLanguageRTL(locale);
  const lastGameDataFetcher = useLastGameDataFetcher();
  const currency = useGameStateSlice.getCurrency() ?? '';
  const currentLanguage = useSettingsSlice.currentLanguage();
  const lastGameData = useHighflyerGameStateSlice.lastGameData();
  const isLoading = useHighflyerGameStateSlice.getIsLoadingPreviousGameData();
  const isLoadMore = useHighflyerGameStateSlice.getIsLoadMorePreviousGameData();
  const currentGameData = useHighflyerGameStateSlice.leaderBoardHistory()?.user;

  const mods = useModifiers(
    styles,
    'betHistory_header_row',
    {
      small: currency === 'mBTC' || ['bn', 'hi', 'ar'].includes(currentLanguage),
      rtl: isLanguageRTL,
    },
    { withBaseClass: true }
  );

  return (
    <>
      <table className={styles.betHistory_table}>
        <div className={styles.header_border}></div>
        <thead className={styles.betHistory_header}>
          <tr className={mods}>
            <td className={styles.firstCol}>
              <L10nText tk="USER" />
            </td>
            <td className={styles.secondCol}>
              <L10nText tk="BETLABEL" /> 
              <span>&nbsp;{currencySymbol}</span>
            </td>
            <td className={styles.thirdCol}></td>
            <td className={styles.fourthCol}>
              <L10nText tk="CASHED" />
              <span>&nbsp;{currencySymbol}</span>
            </td>
          </tr>
        </thead>
        <tbody className={styles.betHistory_body}>
          <SingleBetRow data={!show ? lastGameData?.players : currentGameData} show={show} />
        </tbody>
      </table>
      {lastGameData?.players && lastGameData.players.length > 0 && !show && isLoadMore && (
        <div className={styles.loadMore}>
          <Button
            tk="LOAD_MORE"
            variant={ButtonVariant.MAIN}
            disabled={!isLoadMore}
            loading={!isLoading}
            onClick={() => {
              setPage((prev) => prev + 1);
              audioTrigger.play({ name: 'menuClick' });
              lastGameDataFetcher(true, page + 1, lastGameData?.gameId);
            }}
            className={styles.buttonBg}
          ></Button>
        </div>
      )}
    </>
  );
};
